/** 옛 CollectParamForm의 제한 검증 규칙. */
export const LIMIT_MIN = 1
export const LIMIT_MAX = 1000

/** BE GlobalOrderCollectionController.MAX_ORDER_NOS와 함께 유지한다. */
export const ORDER_NOS_MAX = 200
